import { render, staticRenderFns } from "./ProhibitAccess.html?vue&type=template&id=56bb7179&"
import script from "./ProhibitAccess.js?vue&type=script&lang=js&"
export * from "./ProhibitAccess.js?vue&type=script&lang=js&"
import style0 from "./ProhibitAccess.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports